import { Figtree } from 'next/font/google';

export const figtree = Figtree({ subsets: ['latin'] });
const fontFamily = `${figtree.style.fontFamily}`;

const fonts = {
  regular: {
    family: fontFamily,
    weight: '400',
  },
  medium: {
    family: fontFamily,
    weight: '500',
  },
  semibold: {
    family: fontFamily,
    weight: '600',
  },
};

export default fonts;
